import type { Camera, Vector3 } from "three";

/** Shared OrbitControls handle so mobile shield can rotate/zoom without touching the canvas. */
export type TechOrbitHandle = {
  object: Camera;
  target: Vector3;
  minPolarAngle: number;
  maxPolarAngle: number;
  dollyIn: (dollyScale?: number) => void;
  dollyOut: (dollyScale?: number) => void;
  update: () => void;
};

export const techOrbitBridge: { current: TechOrbitHandle | null } = {
  current: null,
};
